// One-time note (design revision 2026-10-19, D5-A): once text messages are on, tell
// signed-in people with no mobile number that they can add one. Dismissed per person
// per device (localStorage); "Add my number" opens the Account settings page.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { useFileContext } from '../../ContextAPI/FileContext';
import { useAuthOptions } from '../../utils/authOptions';
import './SmsAnnouncement.css';

const storageKey = (email) => `smsAnnouncementDismissed:${(email || '').trim().toLowerCase()}`;

function dismissed(email) {
  try {
    return window.localStorage.getItem(storageKey(email)) === '1';
  } catch (e) {
    return false; // storage blocked: showing the note again is harmless
  }
}

function rememberDismissed(email) {
  try {
    window.localStorage.setItem(storageKey(email), '1');
  } catch (e) {
    /* storage blocked: it hides for this page view only */
  }
}

export default function SmsAnnouncement() {
  const { auth, userEmail } = useFileContext();
  const options = useAuthOptions();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const smsOn = options?.sms === true;

  useEffect(() => {
    if (!auth || !smsOn || !userEmail || dismissed(userEmail)) {
      setShow(false);
      return undefined;
    }
    let live = true;
    fetchUserAttributes()
      .then((attrs) => { if (live && !attrs?.phone_number) setShow(true); })
      .catch(() => { /* no note rather than a broken one */ });
    return () => { live = false; };
  }, [auth, smsOn, userEmail]);

  const close = () => {
    rememberDismissed(userEmail);
    setShow(false);
  };

  return (
    <>
      {show && (
        <div className="sms-note" role="status" aria-label="Text-message sign-in codes">
          <p className="sms-note__title">New: sign-in and password-reset codes by text message</p>
          <p className="sms-note__text">
            Add your mobile number in Account settings to get codes by text. It helps when your
            company&apos;s email filter holds back our emails. Your authenticator app keeps working.
          </p>
          <p className="sms-note__text">
            You can change this at any time from <strong>Settings</strong> in the menu on the left.
          </p>
          <div className="sms-note__actions">
            <button type="button" className="sms-note__primary"
              onClick={() => { close(); navigate('/account'); }}>Add my number</button>
            <button type="button" className="sms-note__link" onClick={close}>Not now</button>
          </div>
        </div>
      )}
    </>
  );
}
